import { Component, Input, OnInit } from "@angular/core";
import { Product } from "../../types/product.type";
import { environment } from "../../../../environments/environment";
import { AppSettings } from "../../PRE-LOAD/app-settings";
import { UserSelectionsService } from "../../services/user-selections/user-selections.service";
import { Router } from "@angular/router";
import { StringsService } from "../../services/strings/strings.service";
import { OptionCard } from "../../types/strings.type";
import { ErrorService } from "../../services/errors/error.service";
import { AnalyticsService } from "../../services/analytics/analytics.service";

@Component({
    selector: "rttd-option-card",
    templateUrl: "./option-card.component.html",
    styles: [
        require("./option-card.component.scss").default.toString(),
        require(`./option-card.component.${environment.brand}.scss`).default.toString(),
    ],
})
export class OptionCardComponent implements OnInit {
    @Input() data: Product;
    oldBookingForm: string;
    content: OptionCard;

    constructor(
        private appSettings: AppSettings,
        private userSelectionsService: UserSelectionsService,
        private router: Router,
        private stringsService: StringsService,
        private errorService: ErrorService,
        private analytics: AnalyticsService
    ) {}

    ngOnInit() {
        this.setOldFormUrl();
        this.stringsService.get().subscribe((data: OptionCard) => {
            this.content = data["OptionCard"];
        });
    }

    setOldFormUrl() {
        this.oldBookingForm = [
            this.appSettings.retailerBookingFormUrl,
            `?modelTreeReference=${encodeURIComponent(this.data.modelTreeRef)}`,
            `&carName=${this.data.combinedModelName}`,
        ].join("");
    }

    selectAppointment(data: Product) {
        this.analytics.formStarted();

        if (data.enabled) {
            this.router
                .navigate(["/select-appointment"], { skipLocationChange: true })
                .then(() => {
                    this.userSelectionsService.set("product", data);
                    this.analytics.setModel();
                });
        } else {
            this.redirectToOldForm();
        }
    }

    redirectToOldForm() {
        this.analytics.formStarted();

        window.location.href = this.oldBookingForm;
    }

    getClass(data: Product) {
        let classes: Array<string> = [];
        classes.push(data.enabled ? "active" : "inactive");
        if (data.isElectric) {
            classes.push("typeEv");
        }
        if (data.isHybrid) {
            classes.push("typePhev");
        }
        return classes.join(" ");
    }
}
